import logo from "./logo.svg";
import "./App.css";
import Header from "./Components/Header/Header";
import Textform from "./Components/Textform/Textform";
import Footer from "./Components/Footer/Footer";


function App() {
   return (
      <>
         <Header />
         <Textform />
         <Footer />
      </>
   );
}

export default App;